<template>
  <f7-photo-browser ref="pb" :id="id+'pb'" :photos="photos" :backLinkText="$theme.ios ? resource.closeBtn : ''" :ofText="resource.ofText" :toolbar="handleNextPrevToolbar()">
  </f7-photo-browser>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    photos: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters([
      'resource'
    ])
  },
  methods : {
    handleNextPrevToolbar () {
      if (this.photos.length === 1 && this.photos[0].title == 'profilepiczoom') {
        return false
      } 
      else {
        return true
      }
    }
  }
}
</script>
<style scoped>
.photo-browser-captions-light .photo-browser-caption {
   bottom: 0px;
   left:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/ImageFullScreen.vue